// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Message-messagesWrapper-YUrIq {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 3px;
}

.Message-messageNotify-vv5DG {
  background-color: var(--alert-color);
  height: 7px;
  width: 7px;
  border-radius: 50%;
  margin-top: -14px;
}`, "",{"version":3,"sources":["webpack://./src/components/Message/Message.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".messagesWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.messageNotify {\n  background-color: var(--alert-color);\n  height: 7px;\n  width: 7px;\n  border-radius: 50%;\n  margin-top: -14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagesWrapper": `Message-messagesWrapper-YUrIq`,
	"messageNotify": `Message-messageNotify-vv5DG`
};
module.exports = ___CSS_LOADER_EXPORT___;
